import React, { FC, useEffect, useState } from "react";
import { RecommendationDto } from "@green0meter/api-client";

// TODO rename to RecommendationDetails
import RecomendationDetail from "./RecommendationDetails";

import { useRecommendationsApi } from "@api";
import { useUserStore } from "@store/user";

interface RecommendationDetailsContainer {
  recommendationId?: string;
}

const RecommendationDetailsContainer: FC<RecommendationDetailsContainer> = ({
  recommendationId,
}) => {
  const { user } = useUserStore();
  const [recommendationDetail, setRecommendationDetail] =
    useState<RecommendationDto>();
  const { isLoadingRecommendations, recommendations, recommendationsEnabled } =
    useRecommendationsApi(user);

  useEffect(() => {
    if (recommendationId) {
      setRecommendationDetail(
        recommendations?.find((r) => r.external_id === recommendationId),
      );
    }
  }, [recommendations, recommendationId]);

  if (isLoadingRecommendations) {
    // @TODO add skeleton
    return "loading...";
  }

  return (
    recommendationsEnabled &&
    (recommendationDetail ? (
      <RecomendationDetail recommendation={recommendationDetail} />
    ) : (
      "recommendation not found..."
    ))
  );
};

export default RecommendationDetailsContainer;
